// extracted by mini-css-extract-plugin
export default {"alerts_container":"App_alerts_container__xRn-U","actions_container":"App_actions_container__NhaKK","close":"App_close__lJ9vO","alert_body":"App_alert_body__3rR6V"};